module.exports = __webpack_public_path__ + "img/steam-engine-H.8e1fa682.png";